import React, {Component} from "react";
import Store from "../../store";
import {observer} from "mobx-react";
import {Officer} from "../../entities/officer";
import {Container, FormControl, Input, InputLabel, OutlinedInput, TextField} from "@mui/material";
import RenewalStore from "../../stores/renewal-store";
import {InlineButton} from "../buttons";
import editButtonAction from "../../ui/renewal/renewal-edit-button-action";
import {formatAddressLocality} from "../../assets/address-details";

class OfficersList extends Component<{ officers: any; addressOnly?: boolean }> {
    render() {
        let {officers} = this.props;
        // console.log(officers);
        return (
            <Container key={JSON.stringify(officers)} disableGutters sx={{display:'grid', gridTemplateColumns:{xs: 'repeat(1, 1fr)', md:'repeat(2, 1fr)'}, gridColumnGap:{xs: 16, md: 48}}}>
                {RenewalStore.getUpdatedCompanyInfo.officers.map((officer, index) =>
                    <OfficeElement index={index} key={JSON.stringify(officer)} officer={new Officer(officer)} addressOnly={this.props.addressOnly}/>)}
            </Container>
        );
    }
}

const OfficeElement = observer(
    ({officer, index, addressOnly = false}: { officer: Officer, index:number, addressOnly?: boolean }) => {
        let isSelected = Store.getSelectedOfficer == officer.id;
        return (
            <Container disableGutters sx={{display:'flex', flexDirection:'column', textDecoration:RenewalStore.getUpdatedCompanyInfo.officers[index].remove == true ? "line-through": undefined }}>
                <FormControl>
                    <InputLabel shrink sx={{marginLeft:"-5px", width: 'calc(133% - 32px)'}}>
                        <div style={{display:"flex", justifyContent:"space-between"}}>
                            <div style={{background: "white", paddingLeft: 5, paddingRight: 10}}>
                                <span>{'Title: ' + RenewalStore.getUpdatedCompanyInfo.officers[index].title}</span>
                                {RenewalStore.getUpdatedCompanyInfo.officers[index].remove == undefined ? <InlineButton onClick={() => editButtonAction({
                                    field: "officer",
                                    index: index,
                                    addressOnly,
                                })}>Change</InlineButton> : <></>}
                            </div>
                            {!addressOnly && <div style={{background: "white", paddingRight: 10}}>
                                <InlineButton onClick={() => {
                                    if(RenewalStore.getUpdatedCompanyInfo.officers[index].remove == true){
                                        delete RenewalStore.getUpdatedCompanyInfo.officers[index].remove;
                                    }else{
                                        RenewalStore.getUpdatedCompanyInfo.officers[index].remove = true
                                    }
                                }}>{RenewalStore.getUpdatedCompanyInfo.officers[index].remove == true ? "Restore" : "Remove"}</InlineButton>
                            </div>}
                        </div>

                    </InputLabel>
                    <TextField id={`test${index}`} disabled
                        //                label={
                        //     <>
                        //     <span>{'Title: ' + RenewalStore.getUpdatedCompanyInfo.officers[index].title}</span>
                        //     <InlineButton onClick={() => editButtonAction({field:"officer", index:index})}>Change</InlineButton>
                        //     </>
                        // }
                                   value={`${RenewalStore.getUpdatedCompanyInfo.officers[index].firstName} ${RenewalStore.getUpdatedCompanyInfo.officers[index].lastName}`}/>

                </FormControl>
                <TextField disabled margin='dense' value={`${RenewalStore.getUpdatedCompanyInfo.officers[index].address} `}/>
                <TextField sx={{mb:3}} disabled margin='dense' value={formatAddressLocality(RenewalStore.getUpdatedCompanyInfo.officers[index])}/>
            </Container>


            // <div data-selected={isSelected ? "true" : "false"}
            //      onClick={() => Store.setSelectedOfficer(officer.id)}
            //      key={officer.id}>
            //     {officer.first_name} {officer.last_name} {isSelected ? "(selected)" : ""} </div>
        )
    }
)


export default OfficersList
